import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  TimePicker,
  Row,
  Col,
  Input,
  Tag,
  Button,
  InputNumber,
} from "antd";
import { getMinute } from "../../../../Function";
import moment from "moment";
import { DeleteOutlined } from "@ant-design/icons";

const getClassColorOT = (type) => {
  let result;
  switch (type) {
    case "Done":
      result = "";
      break;
    case "Processing":
      result = "";
      break;
    case "Error":
      result = "timekeeper-error";
      break;
    default:
      result = "";
      break;
  }
  return result || "";
};

const ModalDetailItem = ({
  visible,
  onCancel,
  itemDetail,
  currentDate,
  updateData,
}) => {
  const [form] = Form.useForm();
  const [lsDuAn, setLsDuAn] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [timeStart, setTimeStart] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);
  const [timeStartCa2, setTimeStartCa2] = useState(null);
  const [timeEndCa2, setTimeEndCa2] = useState(null);
  const [timeStartHT, setTimeStartHT] = useState(
    itemDetail["time_system_" + currentDate]
      ? moment(
          moment(new Date()).format("YYYYMMDD") +
            itemDetail["time_system_" + currentDate].split("-")[0],
          "YYYYMMDDHH:mm"
        )
      : null
  );
  const [timeEndHT, setTimeEndHT] = useState(
    itemDetail["time_system_" + currentDate]
      ? moment(
          moment(new Date()).format("YYYYMMDD") +
            itemDetail["time_system_" + currentDate].split("-")[1],
          "YYYYMMDDHH:mm"
        )
      : null
  );

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        nhanvien: itemDetail.nhanvien,
      });

      const timeRanges = itemDetail["time_regist_" + currentDate].includes("&&")
        ? String(itemDetail["time_regist_" + currentDate]).split("&&")
        : itemDetail["time_regist_" + currentDate];
      const valueVaoCa1 =
        timeRanges.length !== 2
          ? timeRanges.split("-")[0]
          : timeRanges[0]
          ? timeRanges[0].split("-")[0]
          : "";

      const valueRaCa1 =
        timeRanges.length !== 2
          ? timeRanges.split("-")[1]
          : timeRanges[0]
          ? timeRanges[0].split("-")[1]
          : "";
      const valueVaoCa2 =
        timeRanges.length === 2 ? timeRanges[1].split("-")[0] : null;
      const valueRaCa2 =
        timeRanges.length === 2 ? timeRanges[1].split("-")[1] : null;

      if (itemDetail.hasOwnProperty("col" + currentDate)) {
        form.setFieldsValue({
          ngay: moment(
            itemDetail["col" + currentDate].ngay,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY"),
          // gioVaoDK: itemDetail['col'+currentDate].gioVaoDK !="" ? moment(itemDetail['col'+currentDate].gioVaoDK,'HH:mm:ss') : "",
          giovaodangky: valueVaoCa1,
          gioradangky: valueRaCa1,
          giovaodkca2: valueVaoCa2,
          gioradkca2: valueRaCa2,
          giovaothucte: itemDetail["time_actual_" + currentDate]
            ? itemDetail["time_actual_" + currentDate].split("-")[0]
            : "",
          giorathucte: itemDetail["time_actual_" + currentDate]
            ? itemDetail["time_actual_" + currentDate].split("-")[1]
            : "",
          giovaohethong: itemDetail["time_system_" + currentDate]
            ? itemDetail["time_system_" + currentDate].split("-")[0]
            : "",
          giorahethong: itemDetail["time_system_" + currentDate]
            ? itemDetail["time_system_" + currentDate].split("-")[1]
            : "",
          phutdangky: itemDetail["col" + currentDate].phutdangky,
          phutthucte: itemDetail["col" + currentDate].phutthucte,
          giailao: itemDetail["col" + currentDate].gioGiailao || "0",
          giogiailaoca1: itemDetail["col" + currentDate].gio_giai_lao_1 || "0",
        });
      }
      itemDetail.hasOwnProperty("col" + currentDate) &&
        setLsDuAn(itemDetail["col" + currentDate].listDuan);

      setTimeStart(
        itemDetail["time_regist_" + currentDate]
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueVaoCa1,
              "YYYYMMDDHH:mm"
            )
          : null
      );
      setTimeEnd(
        itemDetail["time_regist_" + currentDate]
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueRaCa1,
              "YYYYMMDDHH:mm"
            )
          : null
      );
      setTimeStartCa2(
        valueVaoCa2 !== null
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueVaoCa2,
              "YYYYMMDDHH:mm"
            )
          : null
      );
      setTimeEndCa2(
        valueRaCa2 !== null
          ? moment(
              moment(new Date()).format("YYYYMMDD") + valueRaCa2,
              "YYYYMMDDHH:mm"
            )
          : null
      );
    }
  }, [visible]);

  const onFinish = (values) => {
    onCancel();
  };
  const onCancelModal = () => {
    updateData();
    onCancel();
    setIsEditing(false);
  };
  const tailLayout = {
    wrapperCol: { offset: 9, span: 15 },
  };

  const getDisableHourOutEdit = () => {
    const timeIn = timeStart ? timeStart._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  const getDisableHourInEdit = () => {
    const timeIn = timeEnd ? timeEnd._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item > timeIn);
  };

  const getDisableHourOutEditHT = () => {
    const timeIn = timeStartHT ? timeStartHT._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  const getDisableHourInEditHT = () => {
    const timeIn = timeEndHT ? timeEndHT._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item > timeIn);
  };

  const handleClickDeleteStartCa1 = () => {
    setTimeStart(null);
    form.setFieldsValue({ giovaodangky: null });

    setTimeEnd(null);
    form.setFieldsValue({ gioradangky: null });

    setTimeStartCa2(null);
    form.setFieldsValue({ giovaodkca2: null });

    setTimeEndCa2(null);
    form.setFieldsValue({ gioradkca2: null });
  };

  const handleClickDeleteEndCa1 = () => {
    setTimeEnd(null);
    form.setFieldsValue({ gioradangky: null });

    setTimeStartCa2(null);
    form.setFieldsValue({ giovaodkca2: null });

    setTimeEndCa2(null);
    form.setFieldsValue({ gioradkca2: null });
  };

  const handleClickDeleteStartCa2 = () => {
    setTimeStartCa2(null);
    form.setFieldsValue({ giovaodkca2: null });

    setTimeEndCa2(null);
    form.setFieldsValue({ gioradkca2: null });
  };

  const handleClickDeleteEndCa2 = () => {
    setTimeEndCa2(null);
    form.setFieldsValue({ gioradkca2: null });
  };

  const getDisableHourInEditCa2 = () => {
    // @ts-ignore
    const timeIn = timeEndCa2 ? timeEndCa2._d.getHours() : 24;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter(
      (item) => item > timeIn || item < new Date(timeEnd).getHours()
    );
  };

  const getDisableHourOutEditCa2 = () => {
    // @ts-ignore
    const timeIn = timeStartCa2 ? timeStartCa2._d.getHours() : 0;
    let arrCheck = [...Array(24).keys()];
    return arrCheck.filter((item) => item < timeIn);
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancelModal}
      title={"Chi tiết tăng ca"}
      style={{ minWidth: "800px" }}
      footer={false}
      className={
        itemDetail.hasOwnProperty("col" + currentDate)
          ? `${getClassColorOT(itemDetail["col" + currentDate].type)}-modal`
          : ""
      }
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        layout={"vertical"}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="nhanvien" label="Nhân viên">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="ngay" label="Thời gian" style={{ width: "100%" }}>
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16} className="lich_dang_ky_ca">
          <Col span={24} style={{ paddingTop: 10, textAlign: "center" }}>
            <h4 style={{ fontWeight: 700 }}>Ca 1</h4>
          </Col>
          <Col span={4} style={{ display: "flex" }}>
            <Form.Item name="giovaodangky" label="Giờ vào đăng ký">
              {isEditing ? (
                <TimePicker
                  format="HH:mm"
                  placeholder={"Giờ vào"}
                  // inputReadOnly={true}
                  allowClear={false}
                  // @ts-ignore
                  value={timeStart}
                  // @ts-ignore
                  onSelect={(value) => {
                    setTimeStart(value);
                    form.setFieldsValue({ giovaodangky: value });
                  }}
                  disabledHours={getDisableHourInEdit}
                  style={{ borderRadius: 10, width: "100%" }}
                  showNow={false}
                />
              ) : (
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={1} style={{ margin: "auto" }}>
            {isEditing && timeStart !== null && (
              <Button
                className="button-delete-ot"
                onClick={handleClickDeleteStartCa1}
              >
                <DeleteOutlined className="icon-delete-ot" />
              </Button>
            )}
          </Col>
          <Col span={4} offset={1}>
            <Form.Item name="gioradangky" label="Giờ ra đăng ký">
              {isEditing ? (
                <TimePicker
                  status={timeStart !== null && timeEnd === null ? "error" : ""}
                  format="HH:mm"
                  placeholder={"Giờ ra"}
                  // inputReadOnly={true}
                  // @ts-ignore
                  value={timeEnd}
                  allowClear={false}
                  // @ts-ignore
                  onSelect={(value) => {
                    setTimeEnd(value);
                    form.setFieldsValue({ gioradangky: value });
                  }}
                  disabledHours={getDisableHourOutEdit}
                  style={{ borderRadius: 10, width: "100%" }}
                  showNow={false}
                  disabled={timeStart === null && true}
                />
              ) : (
                <Input disabled />
              )}
            </Form.Item>
          </Col>
          <Col span={1} style={{ margin: "auto" }}>
            {isEditing && timeEnd !== null && (
              <Button
                className="button-delete-ot"
                onClick={handleClickDeleteEndCa1}
              >
                <DeleteOutlined className="icon-delete-ot" />
              </Button>
            )}
          </Col>
          <Col span={11} offset={2}>
            <Form.Item name="giogiailaoca1" label="Giải lao">
              <InputNumber
                min={0}
                disabled={!isEditing}
                style={{ borderRadius: 10, width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        {timeStartCa2 !== null && timeEndCa2 !== null && (
          <Row gutter={16} className="lich_dang_ky_ca">
            <Col span={24} style={{ paddingTop: 10, textAlign: "center" }}>
              <h4 style={{ fontWeight: 700 }}>Ca 2</h4>
            </Col>
            <Col span={4} style={{ display: "flex" }}>
              <Form.Item name="giovaodkca2" label="Giờ vào đăng ký">
                {isEditing ? (
                  <TimePicker
                    status={
                      timeStartCa2 === null && timeEndCa2 !== null
                        ? "error"
                        : ""
                    }
                    format="HH:mm"
                    placeholder={"Giờ vào"}
                    // inputReadOnly={true}
                    allowClear={false}
                    // @ts-ignore
                    value={timeStartCa2 || null}
                    // @ts-ignore
                    onSelect={(value) => {
                      setTimeStartCa2(value);
                      form.setFieldsValue({ giovaodkca2: value });
                    }}
                    disabledHours={getDisableHourInEditCa2}
                    style={{ borderRadius: 10, width: "100%" }}
                    showNow={false}
                  />
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>
            <Col span={1} style={{ margin: "auto" }}>
              {isEditing && timeStartCa2 !== null && (
                <Button
                  className="button-delete-ot"
                  onClick={handleClickDeleteStartCa2}
                >
                  <DeleteOutlined className="icon-delete-ot" />
                </Button>
              )}
            </Col>
            <Col span={4} offset={1}>
              <Form.Item name="gioradkca2" label="Giờ ra đăng ký">
                {isEditing ? (
                  <TimePicker
                    status={
                      timeStartCa2 !== null && timeEndCa2 === null
                        ? "error"
                        : ""
                    }
                    format="HH:mm"
                    placeholder={"Giờ ra"}
                    // inputReadOnly={true}
                    // @ts-ignore
                    value={timeEndCa2}
                    allowClear={false}
                    // @ts-ignore
                    onSelect={(value) => {
                      setTimeEndCa2(value);
                      form.setFieldsValue({ gioradkca2: value });
                    }}
                    disabledHours={getDisableHourOutEditCa2}
                    style={{ borderRadius: 10, width: "100%" }}
                    showNow={false}
                    disabled={timeStartCa2 === null && true}
                  />
                ) : (
                  <Input disabled />
                )}
              </Form.Item>
            </Col>
            <Col span={1} style={{ margin: "auto" }}>
              {isEditing && timeEndCa2 !== null && (
                <Button
                  className="button-delete-ot"
                  onClick={handleClickDeleteEndCa2}
                >
                  <DeleteOutlined className="icon-delete-ot" />
                </Button>
              )}
            </Col>
            <Col span={11} offset={2}>
              <Form.Item name="giailao" label="Giải lao">
                <InputNumber
                  min={0}
                  disabled={!isEditing}
                  style={{ borderRadius: 10, width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        {isEditing ? (
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="giovaohethong" label="Giờ vào hệ thống">
                <TimePicker
                  format="HH:mm"
                  placeholder={"-"}
                  inputReadOnly={true}
                  allowClear={false}
                  value={timeStartHT}
                  onSelect={(value) => {
                    setTimeStartHT(value);
                    form.setFieldsValue({ giovaohethong: value });
                  }}
                  disabledHours={getDisableHourInEditHT}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="giorahethong" label="Giờ ra hệ thống">
                <TimePicker
                  format="HH:mm"
                  placeholder={"-"}
                  inputReadOnly={true}
                  value={timeEndHT}
                  allowClear={false}
                  onSelect={(value) => {
                    setTimeEndHT(value);
                    form.setFieldsValue({ giorahethong: value });
                  }}
                  disabledHours={getDisableHourOutEditHT}
                />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="giailao" label="Giải lao">
              <Input disabled={!isEditing} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Dự án">
              {lsDuAn &&
                lsDuAn.map((item) => (
                  <Tag key={item.idDuan}>{item.tenDuan}</Tag>
                ))}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="giovaothucte" label="Giờ vào thực tế">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="giorathucte" label="Giờ ra thực tế">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="phutdangky" label="Số phút đăng ký">
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="phutthucte" label="Số phút thực tế">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalDetailItem;
